import React from 'react';
import {Row} from 'antd'


class NotFound extends React.Component {
  render () {

     return (	     
	   <div>
	 
	   <Row type="flex" justify="center" align="middle"  style={{ minWidth:'60vh',minHeight:'69vh'  }} >
				<h1 style={{fontSize:'30px'}}>404 Error ,Not found! </h1>				
				</Row>
				
		</div>
    );
  }
}

export  default NotFound;
